// extracted by mini-css-extract-plugin
export default {"boardContainer":"about_boardContainer__K8jHd","boardMember":"about_boardMember__Vf8NN","boardImage":"about_boardImage__ETKUJ","aboutContainer":"about_aboutContainer__1OS6S"};